/* ÁGUAS DE IPANEMA — accordion global de Perguntas Frequentes (snippets/aip-faq.liquid).
   Delegação no documento: vale para qualquer FAQ da página, inclusive seções que o
   Theme Editor recarrega. Botão nativo = Enter/Espaço pelo teclado; aria-expanded e
   aria-controls ficam sempre em sincronia. Várias perguntas podem ficar abertas. */
(function () {
  if (window.__aipFaqGlobal) return;
  window.__aipFaqGlobal = true;
  function alternar(btn, abrir) {
    var item = btn.closest('.aip-faq__item');
    if (!item) return;
    var aberto = typeof abrir === 'boolean' ? abrir : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', aberto ? 'true' : 'false');
    item.classList.toggle('is-open', aberto);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.aip-faq__q');
    if (!btn) return;
    e.preventDefault();
    alternar(btn);
  });
  /* abre a pergunta apontada por âncora (#faq-xyz) */
  function porHash() {
    if (!location.hash) return;
    var alvo = document.getElementById(location.hash.slice(1));
    var item = alvo && alvo.closest && alvo.closest('.aip-faq__item');
    if (item) alternar(item.querySelector('.aip-faq__q'), true);
  }
  window.addEventListener('hashchange', porHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porHash); else porHash();
  window.aipFaq = { alternar: alternar };
})();
